import { superstyled } from '@zenbusiness/zui/styles';
import WistiaPlayer from '@zenbusiness/zui/WistiaPlayer';

export const Video = superstyled({
  name: 'Video',
  slot: 'Root',
  tag: WistiaPlayer,
  styles: ({ theme }) => ({
    borderRadius: theme.shape.rounded.lg,
    overflow: 'hidden',

    [theme.breakpoints.up('lg')]: {
      borderRadius: theme.shape.rounded['2xl']
    }
  })
});
